import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Layout } from '../../components/Layout/Layout';
import { LayoutForm } from '../../components/LayoutForm/LayoutForm';
import { BenefitsSection } from '../../components/BenefitsSection/BenefitsSection';
import { IRegisterFieldsValues, RegisterForm } from '../../components/RegisterForm/RegisterForm';
import { RegisterFormFooter } from '../../components/RegisterFormFooter/RegisterFormFooter';

import { registerUser } from '../../store/User/actions/registerUser';
import { selectRegisteringUser } from '../../store/User/reducer';
import { toggleRegisteringUser } from '../../store/User/actions/toggleRegisteringUser';

export const Register = () => {
    const dispatch = useDispatch();
    const registeringUser = useSelector(selectRegisteringUser);
    const submitHandler = (formValues: IRegisterFieldsValues): void => {
        dispatch(registerUser(formValues.name, formValues.email, formValues.password));
        dispatch(toggleRegisteringUser(true));
    };
    const leftTemplate = () => (
        <LayoutForm footer={<RegisterFormFooter />}>
            <RegisterForm submitHandler={submitHandler} formDisabled={registeringUser} />
        </LayoutForm>
    );
    const rightTemplate = () => <BenefitsSection />;
    return <Layout left={leftTemplate} right={rightTemplate} />;
};
